import { AxiosError } from 'axios';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { analytics } from '../../utils/analytics';
import { post } from '../apiService';
import { invalidateProviderByIdCache } from './getProviderById';

type response = {
  status: string;
  providerId?: string;
  message?: string;
};

export const createProvider = async (
  body?: object,
): Promise<{
  data: response;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }
  if (!body) {
    throw new Error('Body is not available');
  }
  const url = `resourceMatrix/providers/create?customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    const data = responseData as response;
    if (data.providerId) {
      invalidateProviderByIdCache(data.providerId);
    }
    loading = false;
    analytics.trackEvent('create', 'provider');
    return { data, loading };
  } catch (error) {
    loading = false;
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error('Failed to create provider item');
  }
};
